/**
 * One `engagement` request per bio page (v149.64).
 *
 * `GET /public/creators/{slug}/engagement` answers both what the
 * engagement bar needs (likes, liked, followers, follow-OTP) and what
 * `useCreatorLoyalty` needs (the loyalty program). Each asked separately —
 * and each product card asked again — so a bio page made 2–7 of these.
 * Callers now share the request in flight, and an answer a few seconds
 * old; it is not kept longer, because likes / followers change.
 *
 * The visitor id the bar stores (`hub_vid`) is sent when there is one, so
 * `liked` is right for whoever asks first.
 */
const FRESH_MS = 5000;
const inflight = new Map();   // slug -> Promise<json>
const recent = new Map();     // slug -> { at, data }

export function fetchEngagement(slug) {
  const hit = recent.get(slug);
  if (hit && Date.now() - hit.at < FRESH_MS) return Promise.resolve(hit.data);
  if (inflight.has(slug)) return inflight.get(slug);
  let vid = "";
  try { vid = localStorage.getItem("hub_vid") || ""; } catch { /* no storage */ }
  const q = vid ? `?visitor_id=${encodeURIComponent(vid)}` : "";
  const p = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/creators/${encodeURIComponent(slug)}/engagement${q}`)
    .then((r) => r.json())
    .then((data) => { recent.set(slug, { at: Date.now(), data }); return data; })
    .finally(() => { inflight.delete(slug); });
  inflight.set(slug, p);
  return p;
}
